import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Col, Row, Pagination } from "react-bootstrap";
import { NavLink, Outlet, useOutletContext } from "react-router-dom";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import {
  getPrintRequestsOwnerId,
  getPrintRequestsUserId,
  getTransactionFromUserId,
  getUserEarningFromUserId,
} from "store/actions";
import { Oval } from "react-loader-spinner";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import { coversion } from "helpers/constants";
export default function Earnings(props) {
  const user_id = useSelector((s) => s?.Login?.user?._id);
  const { role } = useSelector((s) => s?.Login?.user);
  const { transactionsFromUserID, loading, userEarning } = useSelector(
    (s) => s?.Transactions
  );

  var { printRequestFromOwnerId } = useSelector((s) => s?.Print);
  const [tabs, setTabs] = useState("digital");
  var printLoading = useSelector((s) => s?.Print?.laoding);
  const [buySellData, setBuySellData] = useState([]);
  const [totalEarning, setTotalEarning] = useState([]);
  const [totalPrintAmountMatic, setTotalPrintAmountMatic] = useState(0);
  const [printerEarning, setPrinterEarning] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    if (user_id) {
      dispatch(getPrintRequestsOwnerId({ owner_id: user_id }));
    }
  }, [user_id, dispatch]);

  // fetch digital transaction data....
  useEffect(() => {
    if (user_id) {
      let body = {};
      body.user_id = user_id;
      body.buySell = true;
      if (user_id) {
        dispatch(getTransactionFromUserId(body));
      }
    }
  }, [user_id, dispatch]);

  useEffect(() => {
    if (user_id) {
      let body = {};
      body.user_id = user_id;
      if (user_id) {
        dispatch(getUserEarningFromUserId(body));
      }
    }
  }, [user_id, dispatch]);

  useEffect(() => {
    // ...printRequestFromOwnerId,
    // let merged = [...printRequestFromOwnerId,  ...transactionsFromUserID];

    // // ✅ Sort by created_date (descending: latest first)
    //     merged.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
    //     console.log("thisismerged", merged)
    if (tabs == "digital") {
      setBuySellData(
        transactionsFromUserID?.filter((item) => item.sale_type === "buy")
      );
    } else {
      setBuySellData(printRequestFromOwnerId);
    }

    let totalEarning = 0;
    for (let i = 0; i < transactionsFromUserID.length; i++) {
      const t = transactionsFromUserID[i];

      if (
        t.seller_id === user_id &&
        t.sale_type !== "minted" &&
        t.sale_type !== "bid"
      ) {
        const price = Number(t.price) || 0;
        const copies = Number(t.no_of_copies) || 0;
        const discount = Number(t.seller_disccount_amount) || 0;

        totalEarning += price * copies * 0.8 + discount;
      }
    }
    setTotalEarning(totalEarning);
  }, [transactionsFromUserID, user_id, printRequestFromOwnerId, tabs]);


  const state = {
    options: {
      chart: {
        height: 350,
        id: "basic-bar",
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
      },
      stroke: {
        show: true,
        curve: "smooth",
        lineCap: "butt",
        colors: undefined,
        width: 3,
        dashArray: 0,
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: true,
        borderColor: "#90A4AE",
        strokeDashArray: 0,
        position: "back",
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        row: {
          colors: undefined,
          opacity: 0.5,
        },
        column: {
          colors: undefined,
          opacity: 0.5,
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#90A4AE", "transparent"], // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 50, 100],
        colorStops: [0, 50, 100],
      },
    },
    series: [
      {
        name: "High - 2013",
        data: [28, 80, 90, 60, 75, 50, 65, 87, 54],
      },
      // {
      //   name: "Low - 2013",
      //   data: [12, 11, 14, 18, 17, 13, 13]
      // }
    ],
  };
  
  const [timezone, setTimezone] = useState();
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString);
  }, []);

  useEffect(() => {
    const func = async () => {
      if (printRequestFromOwnerId && printRequestFromOwnerId.length > 0) {

      const soldPhysical = printRequestFromOwnerId.filter( //UPDATE BY ANKIT HIS 3 LINE 
        (item) => item?.item_info?.author_id === user_id
      );
        console.log("phsycial sold earning",soldPhysical);
        const totalPrintAmountdollar = soldPhysical.reduce(
          (acc, request) => acc + Number(request?.seller_earning || 0),
          0
        );

        setPrinterEarning(Number(totalPrintAmountdollar).toFixed(2));

        const maticAmt = await coversion(
          totalPrintAmountdollar,
          "USD",
          "MATIC"
        );

        setTotalPrintAmountMatic(Number(maticAmt).toFixed(4));
      } else {
        setTotalPrintAmountMatic(0.0);
      }
    };

    func();
  }, [printRequestFromOwnerId]);

  console.log("printRequestFromOwnerId",printRequestFromOwnerId);
  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    var x = 0;
    if (buySellData?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(buySellData.length / 10);
    }
    const newPages = [];
    for (let i = 1; i <= x; i++) {
      newPages.push(i);
    }

    setDataLength(newPages);
  }, [buySellData]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (buySellData[i]) {
        arr.push(buySellData[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, buySellData]);

  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values) - 10;
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < buySellData.length) {
      // setSNovalue(buySellData.length)
      valu = Math.ceil(buySellData.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };

  const Artisttabs = (type) => {
    setTabs(type);
  };
  return (
    <Row>
      {(loading || printLoading) && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      {/* <Col lg={12} className="mb-4">
        <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
          <h1 className="mb-0 ">My Earnings</h1>
          <NavLink to={'../withdrawal-fiet'} ><button className="WithdrawFiat">Withdraw Fiat</button></NavLink>
        </div>
      </Col> */}

      <Col lg={12} className="mb-4">
        <Row>
          <Col lg={4} className="mb-4">
            <div className="totalEarning d-flex justify-content-between">
              <div>
                <h2>Total Earning</h2>
                <h3 className="mt-3">
                  {(Number(totalEarning))      // digital sold earning
                  .toFixed(6)} POL
                </h3>
              </div>
              {/* <div> </div> */}
            </div>
          </Col>
          {role !== "USER" && (
            <>
              <Col lg={4} className="mb-4">
                <div className="totalEarning royaltyEarning">
                  <div>
                    <h2>Royalties Earning</h2>
                    <h3 className="mt-3">$ 0</h3>
                  </div>
                </div>
              </Col>

              <Col lg={4} className="mb-4">
                <div className="totalEarning royaltyEarning">
                  <div>
                    <h2>Physical Art Earning</h2>
                    <h3 className="mt-3">$ {printerEarning}</h3>
                  </div>
                </div>
              </Col>
              {/* <Col lg={4} className="mb-4">
            <div className="totalEarning fietEarning">
            <div>
              <h2>Fiat Earning</h2>
              <h3 className="mt-3">$ {Number(fiat_total_earning?.toFixed(2))}</h3>
            </div>
            </div>
          </Col> */}
            </>
          )}
          {buySellData.length < 0 ? (
            <Col lg={12} className="mb-4">
              <div className="NoTransection py-5">
                <img
                  src={"../../images/svg/transectionHistory.svg"}
                  width={170}
                  alt=""
                />
                <h2>No transaction history yet!</h2>
                <h3>Go check out the marketplace and buy some cool items!</h3>
              </div>
            </Col>
          ) : (
            <Col lg={12} className="mb-4">
              <div className="dahboardBox">
                <h5 className="fw-semibold border-bottom pb-3">Activity</h5>
                <div className="artTab mb-4">
                  <ul>
                    <li
                      onClick={() => Artisttabs("digital")}
                      className={tabs === "digital" ? "active" : ""}
                    >
                      Digital Art
                    </li>
                    <li
                      onClick={() => Artisttabs("physical")}
                      className={tabs === "physical" ? "active" : ""}
                    >
                      Physical Art
                    </li>
                  </ul>
                </div>
                <div className="table-responsive tableNft">
                  <table>
                    <thead>
                      <tr>
                        <td className="text-center">No.</td>
                        <td>Event</td>
                        <td>Artwork Name</td>
                        <td>Price</td>
                        <td>Quantity</td>
                        {tabs === "digital" && (
                          <>
                            <td>Method</td>
                            <td>From</td>
                            <td>To</td>
                          </>
                        )}
                        <td>Date</td>
                        {/* <td className="text-center">View</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {dataAfterPagination.length > 0 ? (
                        <>
                          {dataAfterPagination &&
                            dataAfterPagination.map((item, index) => {
                              const isDigital = tabs === "digital";

                              // DIGITAL FIELDS
                              const digitalImage =
                                item?.nft_id?.image_id?.image?.link;
                              const digitalName = item?.nft_id?.name;

                              // PHYSICAL FIELDS
                              const physicalImage =
                                item?.artwork_image ||
                                item?._physical_image?.link ||
                                "/images/no-image.png";

                              const physicalName =
                                item?.artwork_name || // digital
                                item?._physical?.listing_title || // physical title
                                item?.item_info?.name || // image name (test05.jpeg)
                                "Physical Artwork"; // fallback

                              return (
                                <tr key={index}>
                                  <td className="text-center">
                                    {(sNoValue += 1)}
                                  </td>

                                  {/* EVENT */}
                                  <td>
                                    {tabs === "digital"
                                      ? item?.seller_id === user_id
                                        ? "Sold"
                                        : "Bought"
                                      : item?._physical?.owner_id === user_id
                                        ? "sold"
                                        : "Bought"}
                                  </td>
                                  {/* ARTWORK NAME + IMAGE */}
                                  <td>
                                    <img
                                      className="nftimge"
                                      alt=""
                                      src={
                                        isDigital ? digitalImage : physicalImage
                                      }
                                    />
                                    {isDigital ? digitalName : physicalName}
                                  </td>

                                  {/* PRICE */}
                                  <td>
                                    {isDigital
                                      ? item?.price + " POL"
                                      : "$ " +
                                        Number(
                                          item?.seller_earning || 0
                                        ).toFixed(2)}
                                  </td>

                                  {/* QUANTITY */}
                                  <td>{isDigital ? item?.no_of_copies : 1}</td>

                                  {/* DIGITAL METHOD / FROM / TO */}
                                  {isDigital && (
                                    <>
                                      <td>{item?.payment_method || "Fiat"}</td>
                                      <td>
                                        {item?.from?.substring(0, 5)}.....
                                        {item?.from?.substring(
                                          item?.from?.length - 4
                                        )}
                                      </td>
                                      <td>
                                        {item?.to?.substring(0, 5)}.....
                                        {item?.to?.substring(
                                          item?.to?.length - 4
                                        )}
                                      </td>
                                    </>
                                  )}

                                  {/* DATE */}
                                  <td>
                                    {(() => {
                                      let raw = item?.created_date;

                                      // Convert string to number if needed
                                      if (
                                        typeof raw === "string" &&
                                        /^\d+$/.test(raw)
                                      ) {
                                        raw = Number(raw);
                                      }

                                      // Convert seconds → milliseconds
                                      if (
                                        typeof raw === "number" &&
                                        raw.toString().length === 10
                                      ) {
                                        raw = raw * 1000;
                                      }

                                      const final = new Date(raw);

                                      return isNaN(final.getTime())
                                        ? "Invalid Date"
                                        : final.toLocaleString("en-IN", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            hour12: true,
                                          });
                                    })()}
                                  </td>
                                </tr>
                              );
                            })}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="text-center py-4" colSpan={8}>
                              No Data Available
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          )}
        </Row>

        <Col lg={12} className="text-end">
          <Pagination
            className="paginationNew"
            aria-label="Page  navigation example"
          >
            {values > 10 && (
              <div className="d-flex align-items-center gap-2">
                <PaginationItem>
                  <PaginationLink
                    first
                    href="#"
                    onClick={() => handlePagination("<<")}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    previous
                    onClick={() => handlePagination("<")}
                  />
                </PaginationItem>
              </div>
            )}
            {dataLength &&
              dataLength.map((item, i) => (
                <PaginationItem
                  key={i}
                  className={parseInt(item) === values / 10 ? "active" : ""}
                >
                  <PaginationLink
                    href="#"
                    onClick={() => handlePagination(item)}
                  >
                    {item}
                  </PaginationLink>
                </PaginationItem>
              ))}

            {values < buySellData.length && (
              <div className="d-flex">
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    next
                    onClick={() => handlePagination(">")}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    last
                    onClick={() => handlePagination(">>")}
                  />
                </PaginationItem>
              </div>
            )}
          </Pagination>
        </Col>
      </Col>
    </Row>
  );
}
